/** Desktop release channel: the hidden Production / Preview switch and the
 *  Preview version picker. */
export default {
  releaseChannel: "Release channel",
  production: "Production",
  preview: "Preview",
  switchTitle: "Switch to {channel}?",
  switchBody: "Denker restarts and signs in to {channel}.",
  switchAction: "Switch",
  switchFailed: "Couldn't switch the release channel",
  linkTitle: "This link is for Denker {channel}",
  linkBody: "Switch to {channel}, then open the link again.",
  previewVersion: "Preview version",
  latest: "Latest",
  thisVersion: "This version",
  versionsFailed: "Couldn't load the Preview versions",
  installTitle: "Install Preview {version}?",
  installBody:
    "Denker restarts on this version and stays on it until you pick Latest.",
  latestTitle: "Follow the latest Preview?",
  latestBody: "Denker updates to the newest Preview and keeps updating.",
  installAction: "Install",
  latestAction: "Follow latest",
  installFailed: "Couldn't install that version",
} as const;
